module.exports = __webpack_public_path__ + "static/charcount-58ba9716a02ed2b6704073473b11fe71.png";